var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceUserUsers = function SvgInterfaceUserUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6m8 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6M8 7c.551 0 1 .449 1 1s-.449 1-1 1-1-.449-1-1 .449-1 1-1m8 0c.551 0 1 .449 1 1s-.449 1-1 1-1-.449-1-1 .449-1 1-1m-8 6c-3 0-7 1.464-7 3.5V19h22v-2.5c0-2.036-4-3.5-7-3.5-1.284 0-2.738.283-3.996.75C10.744 13.282 9.287 13 8 13m0 2c2.36 0 4.62 1.026 5 1.6v.4H3v-.4c.38-.574 2.64-1.6 5-1.6m8 0c2.36 0 4.62 1.026 5 1.6v.4h-6v-.5c0-.482-.23-.93-.611-1.336A9 9 0 0 1 16 15"
  })));
};
export default SvgInterfaceUserUsers;